export const AUDIO_DEFAULT = {
    isAudioStarted: false,
}
